enum FormFields {
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  Role = 'role',
  Properties = 'properties',
}

const FormFieldsList = [
  FormFields.FirstName,
  FormFields.LastName,
  FormFields.Email,
  FormFields.Role,
  FormFields.Properties,
];

export { FormFields, FormFieldsList };
